import type { SearchFormValues } from '@packages/webshop-search-widget';
import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

export interface SearchWidgetContextType {
  isSearchOverlayOpened: boolean;
  setIsSearchOverlayOpened: (isOpened: boolean) => void;
  currentSearchFormValues: SearchFormValues | undefined;
  setCurrentSearchFormValues: Dispatch<
    SetStateAction<SearchFormValues | undefined>
  >;
  handleSubmit: (values: SearchFormValues) => void;
}

export const SearchWidgetContext = createContext<
  SearchWidgetContextType | undefined
>(undefined);
